// src/pages/Home.jsx
import React, { useEffect, useRef, useState } from "react";

import Hero from "../homeComponents/home/Hero";
import QuickServices from "../homeComponents/home/QuickServices";
import PrimaryActions from "../homeComponents/home/PrimaryActions";
import VehicleSection from "../homeComponents/home/VehicleSection";
import ToursSection from "../homeComponents/home/ToursSection";
import MotorsSection from "../homeComponents/home/MotorsSection";
import ConsultancySection from "../homeComponents/home/ConsultancySection";
import TrustStats from "../homeComponents/home/TrustStats";
import EmergencyCTA from "../homeComponents/home/EmergencyCTA";

import RideBookingModal from "../homeComponents/booking/RideBookingModal";
import AppointmentModal from "../homeComponents/appointment/AppointmentModal";
import ExploreMotors from "../homeComponents/ExploreMotors";

/* =========================================================
   Scroll Reveal Wrapper
========================================================= */

const Reveal = ({
  children,
  className = "",
  delay = 0,
}) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const element = ref.current;

    if (!element) return;

    // Respect reduced-motion preferences
    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    if (reduceMotion) {
      setVisible(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(element);
        }
      },
      {
        threshold: 0.08,
        rootMargin: "0px 0px -60px 0px",
      }
    );

    observer.observe(element);

    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={`
        transition-all
        duration-700
        ease-[cubic-bezier(.22,1,.36,1)]
        motion-reduce:transition-none
        ${visible
          ? "translate-y-0 opacity-100"
          : "translate-y-8 opacity-0"
        }
        ${className}
      `}
      style={{
        transitionDelay: `${delay}ms`,
      }}
    >
      {children}
    </div>
  );
};

/* =========================================================
   Home Page
========================================================= */

const Home = () => {
  const [rideOpen, setRideOpen] = useState(false);
  const [apptOpen, setApptOpen] = useState(false);

  /* =========================
     Ride Booking
  ========================= */

  const openRide = () => {
    setRideOpen(true);
  };

  const closeRide = () => {
    setRideOpen(false);
  };

  /* =========================
     Appointment
  ========================= */

  const openAppt = () => {
    setApptOpen(true);
  };

  const closeAppt = () => {
    setApptOpen(false);
  };

  return (
    <main className="min-h-screen overflow-x-hidden bg-[#F8FAF9] pb-24 md:pb-0">
      {/* =================================================
          HERO
      ================================================= */}

      <section className="relative">
        <Hero onBookRide={openRide} />
      </section>

      {/* =================================================
          QUICK SERVICES
      ================================================= */}

      <Reveal>
        <QuickServices />
      </Reveal>
      {/* =================================================
          VEHICLES
      ================================================= */}

      <Reveal>
        <VehicleSection onBookVehicle={openRide} />
      </Reveal>

      <Reveal>
        <ExploreMotors/>
      </Reveal>
      
      {/* =================================================
          PRIMARY ACTIONS
      ================================================= */}

      <Reveal delay={50}>
        <PrimaryActions
          onBookRide={openRide}
          onBookAppointment={openAppt}
        />
      </Reveal>



      {/* =================================================
          TOURS & TRAVELS
      ================================================= */}

      <Reveal>
        <ToursSection onBookRide={openRide} />
      </Reveal>

      {/* =================================================
          NJV MOTORS
      ================================================= */}

      <Reveal>
        <MotorsSection onBookAppointment={openAppt} />
      </Reveal>

      {/* =================================================
          CONSULTANCY
      ================================================= */}

      <Reveal>
        <ConsultancySection
          onSubmitVehicle={openAppt}
        />
      </Reveal>

      {/* =================================================
          TRUST / STATS
      ================================================= */}

      <Reveal>
        <TrustStats />
      </Reveal>

      {/* =================================================
          EMERGENCY CTA
      ================================================= */}

      <Reveal>
        <EmergencyCTA />
      </Reveal>

      {/* =================================================
          RIDE BOOKING MODAL
      ================================================= */}

      <RideBookingModal
        open={rideOpen}
        onClose={closeRide}
      />

      {/* =================================================
          APPOINTMENT MODAL
      ================================================= */}

      <AppointmentModal
        open={apptOpen}
        onClose={closeAppt}
      />
    </main>
  );
};

export default Home;